type TwoColumnLayoutProps = {
  renderLeftColumn: () => React.ReactNode;
  renderRightColumn: () => React.ReactNode;
};

const TwoColumnLayout = ({ renderLeftColumn, renderRightColumn }: TwoColumnLayoutProps) => {
  return (
    <div className="grid h-screen min-h-0 grid-cols-12 overflow-hidden">
      <div className="col-span-12 ml-auto mr-auto max-h-screen min-h-0 w-full overflow-y-auto md:col-span-7 md:mr-0">
        {renderLeftColumn()}
      </div>
      <div className="hidden h-screen min-h-0 md:col-span-5 md:flex">{renderRightColumn()}</div>
    </div>
  );
};

export default TwoColumnLayout;
